<template>
  <div>
    <Jumbotron title="How To Book?" />

    <b-container class="p-3">
      <!-- DEKSTOP -->
      <div class="d-none d-sm-block mt-3" v-for="(content, index) in contents" :key="'d' + index">
        <!-- Gambar di kiri -->
        <b-row class="mt-5" v-if="index%2!==0">
          <b-col cols="7">
            <b-img
                :src="require('@/assets/icon/how-to-books/' + content.img)"
                fluid
              />
          </b-col>
          <b-col class="center-base vertical">
            <div class="text-left">
              <h2 style="font-weight: 600;">
                {{ content.title }}
              </h2>
              <h4 style="font-weight: 400;">
                {{ content.subtitle }}
              </h4>
            </div>
          </b-col>
        </b-row>

        <!-- Gambar di kanan -->
        <b-row class="mt-5" v-else>
          <b-col class="center-base all">
            <div class="text-right">
              <h2 style="font-weight: 600;">
                {{ content.title }}
              </h2>
              <h4 style="font-weight: 400;">
                {{ content.subtitle }}
              </h4>
            </div>
          </b-col>
          <b-col cols="7">
            <b-img
                :src="require('@/assets/icon/how-to-books/' + content.img)"
                fluid
              />
          </b-col>
        </b-row>
      </div>

      <!-- MOBILE -->
      <b-row class="d-block d-sm-none mt-3" v-for="(content, index) in contents" :key="'m-' + index">
        <b-col cols="12">
          <b-img
            :src="require('@/assets/icon/how-to-books/' + content.img)"
            fluid
          />
        </b-col>
        <b-col cols="12" class="center-base all mt-3">
          <div class="text-center">
            <h3 style="font-weight: 600;">
              {{ content.title }}
            </h3>
            <h5 style="font-weight: 400;">
              {{ content.subtitle }}
            </h5>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-5" />

    </b-container>

    <b-container class="mt-5" />
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron'

export default {
  name: 'HowToBook',
  components: {
    Jumbotron
  },
  data () {
    return {
      contents: [
        {
          img: 'icon-01.png',
          title: 'Order',
          subtitle: 'Masukan dan lengkapi data identitas, kontak, tujuan dan tanggal perjalanan Anda serta informasi lainnya.'
        },
        {
          img: 'icon-02.png',
          title: 'Checkout',
          subtitle: 'Pastikan informasi yang Anda masukan sudah benar dan pilih metode pembayaran.'
        },
        {
          img: 'icon-03.png',
          title: 'Complete Your Payment',
          subtitle: 'Masukan data pribadi Anda, nomor paspor, dan nomor kartu kredit Anda untuk melakukan pembayaran. Sebelum melakukan pembayaran, pastikan Anda sudah membaca terms & condition kami dengan seksama.'
        },
        {
          img: 'icon-04.png',
          title: 'Enjoy Your Personal Guider',
          subtitle: 'Anda akan mendapatkan guide yang akan menemani Anda selama perjalanan Anda. Kenali guide Anda dan tentukan rute perjalanan ideal Anda bersama.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.sg-title {
  font-weight: 900;
}
@media screen and (max-width: 767px) {
  .sg-title {
    font-size: 30px;
  }
}
@media screen and (max-width: 1023px) and (min-width: 768px) {
  .sg-title {
    font-size: 40px;
  }
}
@media screen and (max-width: 1980px) and (min-width: 1023px) {
  .sg-title {
    font-size: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Static/HowToBook.vue